// extracted by mini-css-extract-plugin
export default {"more":"_3oxJ_I9s"};